import React from 'react'
import { CMSOpportunityDetailsCompetitiveAdvantageType } from '../../../lib/types'
import { CMSCardTextImageLayout } from './cms-card-text-image-layout'

const CMSCompetitiveAdvantage = ({
  competitiveAdvantage,
}: {
  competitiveAdvantage?: CMSOpportunityDetailsCompetitiveAdvantageType
}) => {
  if (
    !competitiveAdvantage?.text?.length ||
    !competitiveAdvantage.image ||
    !competitiveAdvantage.imagePosition
  ) {
    return null
  }

  return (
    <CMSCardTextImageLayout
      imagePosition={competitiveAdvantage.imagePosition}
      image={competitiveAdvantage.image}
      cardText={competitiveAdvantage.text}
      dataTestId='cms-competitive-advantage-content'
      imageAltText='Competitive advantage image'
    />
  )
}

export { CMSCompetitiveAdvantage }
